import { ClientSearchSDK, SearchDocumentType } from '@wix/client-search-sdk';
import { AppSettings, createSettingsClient } from '@wix/search-settings-client';
import type { ControllerParams } from '@wix/yoshi-flow-editor';

import { reportError } from './errors';

export function createGetAppSettings(
  params: ControllerParams,
): () => Promise<AppSettings> {
  const { flowAPI } = params;
  const { environment, panoramaClient, httpClient } = flowAPI;
  const settingsClient = createSettingsClient({ httpClient });

  return async () => {
    try {
      return environment.isViewer
        ? await settingsClient.getPublished()
        : await settingsClient.getSaved();
    } catch (error) {
      reportError(panoramaClient, error);
      return settingsClient.getDefault();
    }
  };
}

export function createSearchSDK(
  params: ControllerParams,
  { useRawProductDocuments = false } = {},
): ClientSearchSDK {
  const { flowAPI, controllerConfig } = params;
  const { wixCodeApi } = controllerConfig;
  const { httpClient, environment } = flowAPI;

  return new ClientSearchSDK({
    httpClient,
    siteBaseUrl: wixCodeApi.location.baseUrl,
    language: environment.language,
    timeout: 25000,
    excludeDocumentTypes: [SearchDocumentType.ProGallery],
    useRawProductDocuments,
  });
}
